import t from "@ext/localization/locale/translate";

const SIGN_IN_ERROR_CODES = ["email-missing", "email-missing-yandex", "access-denied", "failed"] as const;

export type SignInErrorCode = (typeof SIGN_IN_ERROR_CODES)[number];

export const SIGN_IN_ERROR_PARAM_NAME = "signInError";

export const parseSignInErrorCode = (value: string | undefined): SignInErrorCode | null =>
	SIGN_IN_ERROR_CODES.find((code) => code === value) ?? null;

const getSignInErrorMessage = (code: SignInErrorCode) => {
	if (code === "email-missing") return t("enterprise-cloud-guest.sign-in-errors.emailMissing");
	if (code === "email-missing-yandex") return t("enterprise-cloud-guest.sign-in-errors.emailMissingYandex");
	if (code === "access-denied") return t("enterprise-cloud-guest.sign-in-errors.accessDenied");
	return t("enterprise-cloud-guest.sign-in-errors.failed");
};

export const GesCloudSignInError = ({ code }: { code: SignInErrorCode }) => (
	<p className="text-sm text-status-error text-center" data-qa="ges-cloud-sign-in-error">
		{getSignInErrorMessage(code)}
	</p>
);
